import { Check, X } from 'lucide-react';
import {
  validatePassword,
  FAILURE_LABELS,
  type PasswordFailure,
  type PasswordValidationContext,
} from '../../shared/utils/passwordValidator';
import type { SecuritySettings } from '../../shared/types/settings';
import styles from './PasswordRulesChecklist.module.css';

export type PasswordRulesChecklistProps = {
  password: string;
  policy: SecuritySettings;
  context?: PasswordValidationContext;
};

function rulesForPolicy(policy: SecuritySettings): PasswordFailure[] {
  const rules: PasswordFailure[] = ['TOO_SHORT'];
  if (policy.passwordRequireUppercase) rules.push('NO_UPPERCASE');
  if (policy.passwordRequireLowercase) rules.push('NO_LOWERCASE');
  if (policy.passwordRequireNumber) rules.push('NO_NUMBER');
  if (policy.passwordRequireSymbol) rules.push('NO_SYMBOL');
  if (policy.passwordCannotContainName) rules.push('CONTAINS_NAME_OR_EMAIL');
  return rules;
}

export function PasswordRulesChecklist({ password, policy, context }: PasswordRulesChecklistProps) {
  const { failures } = validatePassword(password, policy, context);
  const failuresSet = new Set(failures);
  const rules = rulesForPolicy(policy);

  return (
    <ul className={styles.list}>
      {rules.map((rule) => {
        const ok = !failuresSet.has(rule);
        const label =
          rule === 'TOO_SHORT'
            ? `${FAILURE_LABELS[rule]} (${policy.passwordMinLength} caracteres)`
            : FAILURE_LABELS[rule];
        return (
          <li key={rule} className={`${styles.item} ${ok ? styles.ok : ''}`}>
            <span className={styles.icon}>
              {ok ? <Check size={14} /> : <X size={14} />}
            </span>
            {label}
          </li>
        );
      })}
    </ul>
  );
}
